@if (showSuccess) {
  <div class="ui-g-12" role="alert">
    <div class="alert alert-success">
      {{successText}}
    </div>
  </div>
}
@if (showError) {
  <div class="ui-g-12" role="alert">
    <div class="alert alert-danger">
      <span>{{errorText}}</span>
      @if (errorMessages && errorMessages.length > 0) {
        <ul>
          @for (message of errorMessages; track message) {
            <li>{{message}}</li>
          }
        </ul>
      }
    </div>
  </div>
}
